const getVastConfig = ({type = "VAST", container = null, ak, wfn, autoClose = false, isPortrait = false, isBarsHidden = false, vcr: shouldBeHovered = false}) => ({
	type,
	container,
	isBarsHidden,
	isPortrait,
	shouldBeHovered,
	url: `https://loopme.me/api/vast/ads?appId=${ak}&vast=4&vpaid=1&flex=1`,
	autoClose: autoClose === true ? 3 : -1,
	wfn
});

const getHtmlConfig = ({ type, container, ak , wfn, bannerType}) => ({ type, container, ak , wfn, bannerType});

export const getDirectTpl = (adverts, passback) =>
	`<div>
		<div>
			<div id='loopme_flex_1'></div>
			<script src="https://i.loopme.me/html/vast/loopme_flex.js"></script>
			<script>
				var adverts = ${JSON.stringify(adverts)};
				var passback = ${passback.value ? JSON.stringify(passback) : false};
				var config = {
					containerId: 'loopme_flex_1',
					vastTimeout: 250,
					ads: adverts,
					user_consent: '%%USER_CONSENT%%',
				};
				passback && (config.passback = passback);
				L.flex.loader.load(config);
			</script>
		</div>
	</div>`;

export const getPassbackDFPTpl = (url, width, height) =>  (
	`<script src='https://www.googletagservices.com/tag/js/gpt.js'>
		googletag.pubads().definePassback('${url}', [${width}, ${height}]).display();
	</script>`
);

const toCharCodes = passback => passback.split('').map(char => char.charCodeAt(0));

export const getDFPTpl = (adverts, passback) =>
	`<!DOCTYPE html>
	<html>
		<head>
			<meta charset="UTF-8" />
			<title>Friendly iframe</title>
		</head>
		<body></body>
		<script>
			var creativeID = parseInt("%ecid!"),
				dfpSlotWidth = parseInt("%%WIDTH%%"),
				dfpSlotHeight = parseInt("%%HEIGHT%%"),
				isDFP = true,
				dfpSlotElementID;
			window.top.googletag.pubads().addEventListener('slotRenderEnded', function(event) {
				if (event.creativeId === creativeID) {
					dfpSlotElementID = event.slot.getSlotElementId();
					event.slot.setCollapseEmptyDiv(true, true);
					window.top.document.getElementById(dfpSlotElementID).style.height = "0px";
				}
			});
		</script>
		<script type="text/javascript" src="https://i.loopme.me/html/vast/loopme_flex.js" data-pe="%%PATTERN:url%%&coppa=%%TFCD%%&p_env=%eenv!&bundleid=%%SITE%%"  id="LOOPME_script"></script>
			<script>
				var adverts = ${JSON.stringify(adverts)};
				var passback = ${passback.value ? JSON.stringify(passback) : false};
				var config = {
					containerId: 'loopme_flex_1',
					vastTimeout: 250,
					ads: adverts,
					user_consent: '%%USER_CONSENT%%',
				};
				passback && (config.passback = passback);
				L.flex.loader.load(config);
			</script>
	</html>`;

export const getSafeFrame = adverts =>
	`<div id='loopme_flex_1'></div>
    <script src="https://i.loopme.me/html/vast/loopme_flex.js" data-pe="%%PATTERN:url%%&coppa=%%TFCD%%&p_env=%eenv!&bundleid=%%SITE%%" id="LOOPME_script"></script>
    <script>
		var adverts = ${JSON.stringify(adverts)};
		var config = {
			containerId: 'loopme_flex_1',
			isSafeFrame: true,
			ads: adverts,
			user_consent: '%%USER_CONSENT%%',
		};
      L.flex.loader.load(config);
	</script>`;

const prepareHeaderBiddings = (headerBiddings = []) => {
    const DEFAULT_VAST = {
        type: "VAST",
        isPortrait: false
    };

	const isUrlValid = ({url = ''}) => url.startsWith("https://");
	const toGeneratedVast = ({url, isPortrait}, displayPriority) =>
		({ ...DEFAULT_VAST, url, isPortrait, displayPriority: displayPriority + 1 });

	return headerBiddings.filter(isUrlValid).map(toGeneratedVast);
};

export const getTpl = type => (ads, passback = {}, headerBiddings = [], isBarsHidden = false) => {
	const addIsBarsHidden = isBarsHidden => ad => ad.type === "VAST" ? {...ad, isBarsHidden} : ad;
	const adverts = ads
		.map(([_, ad]) => ad.type === 'VAST' ? getVastConfig(ad) : getHtmlConfig(ad))
		.concat(...prepareHeaderBiddings(type !== 'SAFE FRAME' ? headerBiddings : []))
		.map(addIsBarsHidden(isBarsHidden));

	let pb = {};
	if (passback) {
		pb = {
			value: toCharCodes(passback.ak),
			width: passback.width,
			height: passback.height
		}
	}
	switch (type) {
		case 'SAFE FRAME': return getSafeFrame(adverts);
		case 'DFP': return getDFPTpl(adverts, pb);
		case 'DIRECT': return getDirectTpl(adverts, pb);
		case 'ADVERTS': return adverts
		default: return '';
	}
};
